import * as routerUtilities from './utilities/router.js'

export function displayShell() {
    const ownerElement = document.getElementById('js-owner--name')
}

export function displayBrand() {
    const brand = routerUtilities.getSubdomain()

    const logoElements = document.querySelectorAll('.js-logo')

    replaceLogo({ brand, nl: logoElements })
}

export function highlightCurrentPage({ path }) {

}

export function displayFeedyardName({ name }) {
    const primaryNameElement = document.getElementById('js-primary--name')
    primaryNameElement.innerText = name
}

export function displayFeedyardPhone({ phone }) {
    const primaryPhoneElement = document.getElementById('js-primary--phone')
    primaryPhoneElement.innerText = phone
}

export function initializeRememberMe({ shouldRememberMe }) {
    const rememberMeElement = document.getElementById('js-remember')
    rememberMeElement.checked = shouldRememberMe

    const usernameElement = document.getElementById('js-username')
    if (!shouldRememberMe) {
        usernameElement.focus()
    }
}

export function initializeUsername(username) {
    const usernameElement = document.getElementById('js-username')
    const passwordElement = document.getElementById('js-password')
    usernameElement.value = username

    passwordElement.focus()
}

export function toggleLoginButton() {
    const loginButton = document.getElementById('js-button--login')
    loginButton.disabled = !loginButton.disabled
}

export function displayLoginAlert(message) {
    console.info({ message })
}

export function displayOwner({ owner }) {
    const ownerElements = document.querySelectorAll('.js-owner--name')
    ownerElements.forEach((oe) => {
        oe.innerText = owner.name
    })
}

export function displayLastDataRefreshDate(lastCompleteDate) {
    const lcdElements = document.querySelectorAll('.js-last--complete--date')
    lcdElements.forEach((cd) => {
        cd.innerText = lastCompleteDate
    })
}

export function showHideReports(reportSelections) {
    showHideReport('.js-receives', reportSelections.receives)
    showHideReport('.js-deads', reportSelections.deads)
    showHideReport('.js-shipments', reportSelections.ships)
    showHideReport('.js-yardsheets', reportSelections.lotYardsheet)
    showHideReport('.js-closeout--summary', reportSelections.closeOutSummary)
    showHideReport('.js-inventory--valuation', reportSelections.inventoryValuation)
    showHideReport('.js-original--lot-transfers', reportSelections.originalLotTransfers)
}

function showHideReport(reportClass, show){
	const repElements = document.querySelectorAll(reportClass)
    repElements.forEach((rep) => {
		if(show){
			rep.classList.remove('hidden')
		} else{
        	rep.classList.add('hidden')
		}
    })
}

function replaceLogo({ brand, nl }) {
    const logos = Array.from(nl)
    logos.map((l) => (l.src = `/brands/${brand}/logo.png`))
}

function replaceFavicons({ base, brand, nl }) {
    const favicons = Array.from(nl)
    favicons.map((f) => f.setAttribute('href', `/brands/${brand}/favicon.png`))
}

export function displayLoadingAnimation() {
    const loadingElement = document.getElementById('js-loading')
    loadingElement.classList.remove('hidden')
}

export function hideLoadingAnimation() {
    const loadingElement = document.getElementById('js-loading')
    loadingElement.classList.add('hidden')
}

export async function loadTemplates() {
    fetch('/templates.html')
        .then((response) => {
            return response.text()
        })
        .then((html) => {
            const parser = new DOMParser()
            const templates = parser.parseFromString(html, 'text/html')
            const tmpTest = templates.getElementById('js-templates')
            document.body.appendChild(tmpTest)
        })
}

export function toggleMobileMenu() {

    const mobileMenu = document.getElementById('js-mobile-menu')
    mobileMenu.classList.toggle('hidden')

    const menuIconClosed = document.getElementById(
        'js-mobile-menu-icon--closed'
    )
    const menuIconOpen = document.getElementById('js-mobile-menu-icon--open')
    menuIconClosed.classList.toggle('hidden')
    menuIconOpen.classList.toggle('hidden')
}

/**
 * Result container must contain a first child that is not the report
 * Second child must be the report
 */
 export function removeReport() {
    const resultsContainer = document.getElementById('js-results-container')
    const report = resultsContainer.firstChild
    if (report !== null) resultsContainer.removeChild(report)
}

// TODO - more robust and flexible error system
export function displayError({ results }) {
    const errorElement = document.getElementById('js-errors--report')

    errorElement.innerHTML = results.errorMessage
    errorElement.classList.remove('hidden')
}

export function hideErrors() {
    const errorElement = document.getElementById('js-errors--report')

    errorElement.innerHTML = ''
    if (!errorElement.classList.contains('hidden')) {
        errorElement.classList.add('hidden')
    }
}

export function displayConfirmation(header, line1, line2, btn1Text, btn1Function, btn2Text, btn2Function){
	const body = document.body
	const confirmBox = document.getElementById('confirm-box')
	const confirmHeader = document.getElementById('confirm-header')
	const confirmLine1 = document.getElementById('confirm-line1')
	const confirmLine2 = document.getElementById('confirm-line2')
	const confirmBtn1 = document.getElementById('confirm-btn1')
	const confirmBtn2 = document.getElementById('confirm-btn2')
	
	const btn1FunctionMod = function(){
	body.classList.remove('overflow-hidden')
		confirmBox.classList.add('hidden')
		btn1Function.apply(null, arguments)
	}
	
	const btn2FunctionMod = function(){
	body.classList.remove('overflow-hidden')
		confirmBox.classList.add('hidden')
		btn2Function.apply(null, arguments)
	}
	
	body.classList.add('overflow-hidden')
	confirmBox.classList.remove('hidden')
	confirmHeader.innerHTML = header
	confirmLine1.innerHTML = line1
	confirmLine2.innerHTML = line2
	confirmBtn1.innerHTML = btn1Text
	confirmBtn1.onclick= btn1FunctionMod
	confirmBtn2.innerHTML = btn2Text
	confirmBtn2.onclick= btn2FunctionMod
}

function collapse(table, collapseIcon){	
	if(table.dataset.collapsed == 'false'){
		table.dataset.collapsed = 'true'
		collapseIcon.dataset.collapsed = 'true'
	} else{		
		table.dataset.collapsed = 'false'
		collapseIcon.dataset.collapsed = 'false'
	}
}

function addCollapseEvents(page){
	const collapsibles = page.shadowRoot.querySelectorAll('[data-collapsible-id]')
	
	for(const collapsible of collapsibles){
		const collapseIcon = page.shadowRoot.querySelector('#collapse-' + collapsible.dataset.collapsibleId)
		collapseIcon.addEventListener('click',
		            () => {
						collapse(collapsible, collapseIcon)
		            },false
		)
	}
}

export function displayReportResults(page, resultsContainerId){
	const resultsContainer = page.shadowRoot.querySelector(resultsContainerId)

	let hasResults = false
    page._results.forEach((r) => {
        const locationResults = document.createElement('div')
        if (r.data.length > 0) {
            locationResults.innerHTML = page.locationResultsTemplate(r)
			hasResults = true
        } else {
            locationResults.innerHTML = page.locationNoResultsTemplate(r)
        }
        resultsContainer.appendChild(locationResults)
    })

	//mt-template-indent class was added to line yard names up when other yard results have collapse icons.
	//Remove the class if no yards have results.
	if(!hasResults){
		const noResultsTemplates = page.shadowRoot.querySelectorAll('.mt-template-indent')
		noResultsTemplates.forEach((template) => {
			template.classList.remove('mt-template-indent')
		})
	}
	
	addCollapseEvents(page)
}